import { CalendarDays, Clock3, DollarSign, Layers, PaintBucket, Ruler, Users } from "lucide-react";
import Skeleton from "../../../../components/ui/Skeleton";
import useCountUp from "../hooks/useCountUp";
import { fmtCurrency, fmtHrs, fmtInt, fmtQty } from "../utils/format";

function Kpi({ label, value, format, icon: Icon, emphasis, loading }) {
  const animated = useCountUp(value ?? 0);
  return (
    <div className={`flex min-w-0 flex-col gap-0.5 px-3.5 py-2.5 ${emphasis ? "bg-primary text-white" : ""}`}>
      <span className={`flex items-center gap-1.5 text-[10.5px] font-semibold uppercase tracking-wide ${emphasis ? "text-white/75" : "text-text_muted"}`}>
        <Icon size={12} aria-hidden="true" />
        {label}
      </span>
      {loading ? (
        <Skeleton className="mt-1 h-5 w-24" />
      ) : (
        <span className={`truncate tabular-nums ${emphasis ? "text-[19px] font-bold" : "text-[16px] font-semibold text-text_primary"}`} aria-live="polite">
          {format(animated)}
        </span>
      )}
    </div>
  );
}

/** Sticky KPI strip — values animate whenever the calc result changes. */
export default function KpiStrip({ kpis, loading }) {
  const k = kpis || {};
  const items = [
    { key: "bid", label: "Total Bid Price", value: k.bidTotal, format: fmtCurrency, icon: DollarSign, emphasis: true },
    { key: "psf", label: "Price / SF", value: k.pricePerSf, format: fmtCurrency, icon: Ruler },
    { key: "sf", label: "Total Paintable SF", value: k.paintableSf, format: fmtQty, icon: Layers },
    { key: "hrs", label: "Labor Hours", value: k.laborHours, format: fmtHrs, icon: Clock3 },
    { key: "md", label: "Crew Man-days", value: k.manDays, format: fmtHrs, icon: Users },
    { key: "mat", label: "Material $", value: k.materialCost, format: fmtCurrency, icon: PaintBucket },
    { key: "dur", label: "Duration (days)", value: k.durationDays, format: fmtInt, icon: CalendarDays },
  ];
  return (
    <div className="grid grid-cols-7 divide-x divide-border overflow-hidden rounded-[4px] border border-border bg-surface" role="region" aria-label="Estimate totals">
      {items.map(({ key, ...it }) => (
        <Kpi key={key} {...it} loading={loading} />
      ))}
    </div>
  );
}
